/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Standard_Op47Inputs */



/**
* | output |
* | --- |
* | "OP-47 teletext subtitles" |
*
* @param {Embed_Captions_Local_Standard_Op47Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_standard_op47 = /** @type {((inputs?: Embed_Captions_Local_Standard_Op47Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Standard_Op47Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titres télétexte OP-47")
	if (locale === "de") return /** @type {LocalizedString} */ ("OP-47 Teletext-Untertitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli del teletext OP-47")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры телетекста ОП-47")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulos de teletexto OP-47")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("OP-47 图文电视字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OP-47テレテキスト字幕")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओपी-47 टेलीटेक्स्ट उपशीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas de teletexto OP-47")
	return /** @type {LocalizedString} */ ("OP-47 teletext subtitles")
});